import SortingTempl from './sorting.pug';
import Select from '../../core/select/select';

require('../../assets/svg/filter-asc.svg');
require('../../assets/svg/filter-desc.svg');

export default {
  template: SortingTempl(),
  delimiters: ['${', '}}'],
  props: {
    title: {
      type: String,
      default: 'Сортировать:',
    },
    options: {
      type: Array,
      require: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  mounted() {
    this.initSelects();
  },
  methods: {
    initSelects() {
      if (this.$refs.sortingSelect) {
        this.$nextTick(() => {
          new Select(this.$refs.sortingSelect);
        });
      }
    },
    checkValue(e) {
      if (!this.isMobile) {
        const filterName = e.target.dataset.name.split('-');
        const newOption = this.options.filter(item => item.name.split('-')[0] === filterName[0] && item.value !== e.target.value);
        if (newOption.length > 0) {
          if (newOption[0].value.indexOf('asc') !== -1) {
            e.target.classList.remove('desc');
            e.target.classList.add('asc');
          } else {
            e.target.classList.add('desc');
            e.target.classList.remove('asc');
          }
          e.target.value = newOption[0].value;
        }
      }
      this.$emit('set-value', e);
    },
  },
};



// WEBPACK FOOTER //
// ./blocks/sorting/sorting.js